import { render } from "./MentorRelationManage.vue?vue&type=template&id=a0614660&scoped=true"
import script from "./MentorRelationManage.vue?vue&type=script&lang=js"
export * from "./MentorRelationManage.vue?vue&type=script&lang=js"

import "./MentorRelationManage.vue?vue&type=style&index=0&id=a0614660&scoped=true&lang=css"

import exportComponent from "C:\\ProgramData\\Jenkins\\.jenkins\\workspace\\四个火体育_web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a0614660"]])

export default __exports__